module.exports = __webpack_public_path__ + "img/bg_vip@2x.ff146f20.png";